import { Skeleton } from "@mui/material";

/**
 * Row-style skeleton — for tables and stacked list content.
 *
 * Previously each row was wrapped in <Typography variant="h1">, which meant
 * a loading table rendered five real <h1> elements on the page (bad for
 * accessibility and SEO), with a hardcoded row count/height that couldn't
 * be reused anywhere the shape didn't happen to match.
 */
export const TableLoader = ({ rows = 5, height = 75 }) => {
    return (
        <div role="status" aria-busy="true" aria-label="Loading" style={{ display: 'flex', flexDirection: 'column', gap: '14px', width: '100%' }}>
            {Array.from({ length: rows }).map((_, i) => (
                <Skeleton
                    key={i}
                    variant="rounded"
                    animation="wave"
                    height={height}
                    width="100%"
                    sx={{ borderRadius: '8px' }}
                />
            ))}
        </div>
    );
};
